<template>
  <div class="cs-fullheight cs-pagination-container">
    <div class="cs-pagination-header">
      <el-button
        class="cs-pagination-header-add"
        v-if="option.hasAdditionalButton"
        type="primary"
        plain
        @click="handleAdditionalBtn"
      >{{option.additionalButtonText}}</el-button>
      <el-button
        class="cs-pagination-header-add"
        v-if="option.hasAddButton"
        type="primary"
        plain
        icon="el-icon-plus"
        @click="handleAdd"
      >{{option.addButtonText}}</el-button>
      <el-input
        class="cs-pagination-header-search"
        v-if="option.hasSearch"
        placeholder="搜索"
        size="medium"
        clearable
        suffix-icon="el-icon-search"
        v-model="searchWord"
        @change="onSearchConditionChanged"
        @keyup.enter.native="onSearchConditionChanged"
      > </el-input>
      <div
        v-if="option.hasDateSearch"
        class="cs-pagination-searchDate-Container"
      >
        <el-date-picker
          class="cs-pagination-searchDate"
          v-model="searchDate"
          type="daterange"
          align="center"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-button
          class="cs-pagination-header-add"
          type="primary"
          plain
          icon="el-icon-search"
          @click="handleSearch"
        >搜索</el-button>
      </div>
    </div>
    <div class="cs-pagination-table-container">
      <el-table
        stripe
        ref="paginationTable"
        :data="tableData"
        :max-height="maxHeight"
        @sort-change="sortChange"
        @filter-change="filterChange"
        style="width: 100%;"
        @cell-dblclick="handleCellDbClick"
        :row-class-name="getRowClass"
        :cell-class-name="cellStyle"
        header-row-class-name="el-table-header"
        @select="onCheck"
        @selection-change="selectionRowsChange"
        :span-method="objectSpanMethod"
        :show-summary="showSummary"
        :summary-method="summaryMethod"
      >
        <el-table-column
          v-if="option.hasChecked && !!tableData && !!columns && columns.length > 0"
          :label="option.checkedColumnTite"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          :filter-multiple="col.IsFilterMutiple"
          :column-key="col.Name"
          :sortable="!col.IsSortDisabled"
          :sort-by="!!col.SortField ? col.SortField : col.Name"
          :filters="getFilterOptions(col.FilterOptionList)"
          :filter-method="col.IsFilterable ? filterHandler : null"
          :key="colIndex"
          v-for="(col, colIndex) in displayedColumns"
          :prop="col.Name"
          :label="col.Text"
          :min-width="getColumnWidth(col.Width)"
          :fixed="col.IsFixed"
          :class-name="getColumnClass(col, colIndex)"
        >
          <template #default="{row, $index}">
            <component
              v-if="!!col.Component"
              :is="col.Component"
              :data="row"
              :editLocation="editLocation"
              :columnData="col"
              :status="status"
              @reload="onReload"
              @customEvent="customEventHanlder"
            ></component>
            <span
              v-if="!col.Component"
              :class="getCellClass(col, row, colIndex, $index)"
              :style="getCellStyle(col, row, colIndex, $index)"
            >
              <div v-if="col.IsHtml" v-html="getCellValue(col, row, colIndex, $index)"></div>
              <slot v-else :name="col.Name" :value="row[col.Name]" :col="col" :row="row" :colIndex="colIndex" :rowIndex="$index">
                {{getCellValue(col, row, colIndex, $index)}}
              </slot>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="option.hasVideoPackageButton"
          :label="option.enableColumnTite"
        >
          <template #default="{row, $index}">
            <div class="align-center">
              <el-button
                v-show="row.IsShowVideoPackageButton"
                :type="'success'"
                size="mini"
                @click="handleVideoPackage($index, row)"
              >
              <span v-if="row.HasVideoPackage">退视频包</span>
              <span v-else>买视频包</span>
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="option.hasJoinWeChatGroupValidateButton"
          :label="option.enableColumnTite"
        >
          <template #default="{row, $index}">
            <div class="align-center">
              <el-button
                v-show="row.IsShowJoinWeChatGroupValidateButton"
                :type="'success'"
                size="mini"
                @click="handleJoinWeChatGroupValidate($index, row)"
              >{{'进群'}}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="option.hasChangeCourseButton"
          :label="option.enableColumnTite"
        >
          <template #default="{row, $index}">
            <div class="align-center">
              <el-button
                v-show="row.IsShowChangeCourseButton"
                :type="'success'"
                size="mini"
                @click="handleChangeCourse($index, row)"
              >{{'换课'}}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="option.hasEnableButton"
          :label="option.enableColumnTite"
        >
          <template #default="{row, $index}">
            <div class="align-center">
              <el-button
                :type="getEnableButtonClass(row)"
                size="mini"
                @click="handleEnable($index, row)"
              >
                {{getEnableButtonText(row)}}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="option.hasEditButton || option.hasDeleteButtonWithEdit"
          :label="option.editColumnTite"
          :width="!!option.buttonWidth && !!tableData && tableData.length > 0 ? option.buttonWidth : ''"
          :fixed="!!option.fixedAction ? option.fixedAction : false"
        >
          <template #default="{row, $index}">
            <div class="align-center" v-if="option.hasEditButton">
              <el-button
                type="primary"
                size="mini"
                v-show="getRowEditVisible($index, row)"
                @click="handleEdit($index, row)"
              >
                {{getEditButtonText($index, row)}}
              </el-button>
            </div>
            <div class="align-center margin-top-10" v-if="option.hasDeleteButtonWithEdit" v-show="getRowDeleteVisible($index, row)">
              <el-button
                type="danger"
                size="mini"
                :disabled="getRowDeleteDisabled($index, row)"
                @click="handleDelete($index, row)">
                {{getDeleteButtonText(row)}}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="option.hasDeleteButton && !option.hasDeleteButtonWithEdit"
          :label="option.deleteColumnTite"
          :width="!!option.buttonWidth && !!tableData && tableData.length > 0 ? option.buttonWidth : ''"
        >
          <template #default="{row, $index}">
            <div class="align-center">
              <el-button
                type="primary"
                size="mini"
                v-show="getRowDeleteVisible($index, row)"
                @click="handleDelete($index, row)"
              >
                {{getDeleteButtonText(row)}}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in option.additionalColumns"
          :key="item.name"
          :label="item.title"
          :width="item.width || (!!option.buttonWidth && !!tableData && tableData.length > 0 ? option.buttonWidth : '')"
        >
          <template #default="{row, $index}">
            <div class="align-center">
              <el-button
                :type="getTypeForAdditionalColumn(item, $index, row)"
                v-show="getVisibleForAdditionalColumn(item, $index, row)"
                :disabled="getDisabledForAdditionalColumn(item, $index, row)"
                :loading="getLoadingForAdditionalColumn(item, $index, row)"
                size="mini"
                @click="handleAdditional(item.name, $index, row)"
              >
                {{item.buttonText}}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      v-if="option.displayPagination"
      class="cs-pagination"
      background
      @size-change="pageSizeChange"
      @current-change="currentPageChange"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100]"
      :page-size="20"
      layout="total, sizes, prev, pager, next, jumper"
      :total="recordTotal"
    >
    </el-pagination>
  </div>
</template>


<style lang="scss">
.cs-pagination-container {
  position: relative;
  width: 100%;

  .cs-pagination-header {
    text-align: right;
    .cs-pagination-header-add {
      margin-right: 10px;
    }
    .cs-pagination-header-search {
      max-width: 200px;
      display: inline-block;
    }
    .cs-pagination-searchDate-Container {
      display: inline-block;
    }

    .cs-pagination-searchDate {
      min-width: 400px;
      vertical-align: middle;
    }
  }

  .cs-pagination-table-container {
    width: 100%;
    margin-top: 10px;

    .el-table {
      .el-table__body {
        td {
          padding-top: 5px;
          padding-bottom: 5px;
        }
      }
    }

    .color-label {
      background-color: #2ab893;
      color: #fff;
      padding: 5px 8px;
      border-radius: 5px;
      white-space: nowrap;
    }

    .disabled-row {
      color: #bcbcbc;
      .color-label {
        background-color: #b2b2b2;
      }
    }

    .highlight-row{

      td{
        background-color: aqua;
      }

      &:hover{
        td{
           background-color: aqua;
        }
      }
    }

    .color-active {
      color: #2ab893;
    }

    .color-close {
      color: #bcbcbc;
    }
  }

  .cs-pagination {
    margin-top: 3px;
  }
}
</style>

<style lang="scss" scoped>
.cs-pagination-table-container {
  .el-table {
    /deep/ .cell {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
}
</style>

<script>
import accountListAmountCell from "./paginationCells/accountListAmountCell";
import accountListPaymentCell from "./paginationCells/accountListPaymentCell";
import accountListDebtCell from "./paginationCells/accountListDebtCell";
import accountListCommentCell from "./paginationCells/accountListCommentCell";
import accountListEnableCell from "./paginationCells/accountListEnableCell";
import accountListOriginalPriceCell from "./paginationCells/accountListOriginalPriceCell";
import saleQueryWeChatCell from "./paginationCells/saleQueryWeChatCell";
import saleQueryContractCell from "./paginationCells/saleQueryContractCell";
import saleQueryCommentCell from "./paginationCells/saleQueryCommentCell";
import saleQueryContinuePaymentCell from "./paginationCells/saleQueryContinuePaymentCell";
import studentPhoneCell from "./paginationCells/studentPhoneCell";
import salesQueryPaymentDiscoutCell from "./paginationCells/salesQueryPaymentDiscoutCell";
import appointmentStatusCell from "./paginationCells/appointmentStatusCell";
import studentVideoButtonCell from "./paginationCells/studentVideoButtonCell";
import appointmentWatchStatusCell from "./paginationCells/appointmentWatchStatusCell";
import homeworkCommentCell from "./paginationCells/homeworkCommentCell";
import filesCell from "./paginationCells/filesCell";
import emailVideoStudentsCell from "./paginationCells/emailVideoStudentsCell";
import emailVideoExpirationCell from "./paginationCells/emailVideoExpirationCell";
import homeworkIsCompletedCell from "./paginationCells/homeworkIsCompletedCell";
import homeworkScoreCell from "./paginationCells/homeworkScoreCell";
import homeworkScoreEditCell from "./paginationCells/homeworkScoreEditCell";
import homeworkStatusCell from "./paginationCells/homeworkStatusCell";
import homeworkStudentPhoneCell from "./paginationCells/homeworkStudentPhoneCell";
import homeworkActionsCell from "./paginationCells/homeworkActionsCell";
import homeworkCloseOrNotCell from "./paginationCells/homeworkCloseOrNotCell";
import homeworkConditionCell from "./paginationCells/homeworkConditionCell";
import homeworkNameCell from "./paginationCells/homeworkNameCell";
import homeworkTypeCell from "./paginationCells/homeworkTypeCell";
import coursewareNameCell from "./paginationCells/coursewareNameCell";
import coursewareActionsCell from "./paginationCells/coursewareActionsCell";
import coursewareFileNameCell from "./paginationCells/coursewareFileNameCell";
import gradedCommissionCell from "./paginationCells/gradedCommissionCell";
import openCourseNameCell from "./paginationCells/openCourseNameCell";
import studyAbroadAccountListSaleAmountCell from "./paginationCells/studyAbroadAccountListSaleAmountCell";
import studyAbroadUniversityScoreCell from "./paginationCells/studyAbroadUniversityScoreCell";
import autoWorkflowPaymentTypeCell from "./paginationCells/autoWorkflowPaymentTypeCell";
import autoWorkflowStatusCell from "./paginationCells/autoWorkflowStatusCell";
import zhenliuDetectCell from "./paginationCells/zhenliuDetectCell.vue";
import formulaListValueCell from "./paginationCells/formulaListValueCell";
import interviewRecordingCell from "./paginationCells/interviewRecordingCell";
import resumeFileCell from "./paginationCells/resumeFileCell";

export default {
  data() {
    return {
      loading: true,
      tableData: [],
      columns: [],
      displayedColumns: [],
      currentPage: 1,
      recordTotal: 0,
      pageSize: 20,
      sortField: "",
      isDesc: false,
      searchWord: "",
      searchDate: "",
      searchFilter: null,
      enableButtonClass: "primary",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      editLocation: {},
      highlightFields:[]
    };
  },
  components: {
    zhenliuDetectCell,
    accountListAmountCell,
    accountListPaymentCell,
    accountListDebtCell,
    accountListCommentCell,
    accountListEnableCell,
    accountListOriginalPriceCell,
    saleQueryWeChatCell,
    saleQueryContractCell,
    saleQueryCommentCell,
    saleQueryContinuePaymentCell,
    studentPhoneCell,
    salesQueryPaymentDiscoutCell,
    appointmentStatusCell,
    studentVideoButtonCell,
    appointmentWatchStatusCell,
    homeworkCommentCell,
    homeworkScoreEditCell,
    filesCell,
    emailVideoStudentsCell,
    emailVideoExpirationCell,
    homeworkIsCompletedCell,
    homeworkStudentPhoneCell,
    homeworkStatusCell,
    homeworkScoreCell,
    homeworkActionsCell,
    homeworkCloseOrNotCell,
    homeworkConditionCell,
    homeworkNameCell,
    homeworkTypeCell,
    coursewareNameCell,
    coursewareActionsCell,
    coursewareFileNameCell,
    gradedCommissionCell,
    openCourseNameCell,
    studyAbroadAccountListSaleAmountCell,
    studyAbroadUniversityScoreCell,
    autoWorkflowPaymentTypeCell,
    autoWorkflowStatusCell,
    formulaListValueCell,
    interviewRecordingCell,
    resumeFileCell
  },
  created() {
    //this.initSetting();
  },
  props: {
    maxHeight: {
      type: Number,
      default: 600
    },
    data: {},
    option: {},
    displayPagination: Boolean,
    hasEditButton: Boolean,
    editButtonText: String,
    hasDeleteButtonWithEdit: Boolean,
    editColumnTite: String,
    showAcitveColor: Boolean,
    hideDisableRow: Boolean,
    selectedKeyField: String,
    selectedKey: Number | String,
    status: {},
    showSummary: {
      type: Boolean,
      default: false
    },
    summaryMethod: {
      type: Function,
      default: undefined
    },
  },
  methods: {
    checkIsVisiable(col) {
      if (!col.IsHide) {
        if (!!col.VisibleField) {
          // console.log("this.option", this.option);
          // console.log("col.VisibleField", col.Field + " " + col.VisibleField + " " + this.option[col.VisibleField]);
          
          return this.option[col.VisibleField];
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    onReload() {
      this.loadData();
    },
    filterChange(filter) {
      this.searchFilter = filter;
      this.handleSearch();
    },
    getFilterOptions(list) {
      if (!!list && list.length > 0) {
        let options = [];
        list.forEach(element => {
          options.push({
            text: element.Value,
            value: element.Key
          });
        });
        return options;
      }
      return null;
    },
    filterHandler(value, row, column) {
      return true;
    },
    handleCellDbClick(row, column, cell, event) {
      let location = {
        rowIndex: row.Index,
        Id:row.Id,
        columnLabel: column.label
      };
      this.editLocation = location;
      this.$emit("cellDbClick", { column: column, row: row });
    },
    getColumnWidth(value) {
      if (!value) {
        return 100;
      }
      return value;
    },
    getColumnClass(col, colIndex) {
      if (Object.typeOf(this.option.fnCustomColumnClass) === "function") {
        let customValue = this.option.fnCustomColumnClass(col, colIndex);
        if (!!customValue)
          return customValue;
      }

      return "";
    },
    getCellClass(col, row, colIndex, rowIndex) {
      if (Object.typeOf(this.option.fnCustomCellClass) === "function") {
        let customValue = this.option.fnCustomCellClass(col, row, colIndex, rowIndex);
        if (!!customValue)
          return customValue;
      }

      return {
        'color-label': col.IsColorLabel,
        'color-active': row.Active=='已激活' && col.Name =='Active' && this.option.showAcitveColor,
        'color-close':(row.Active=='关闭') && col.Name =='Active' && this.option.showAcitveColor
      };
    },
    getCellStyle(col, row, colIndex, rowIndex) {
      if (Object.typeOf(this.option.fnCustomCellStyle) === "function") {
        let customValue = this.option.fnCustomCellStyle(col, row, colIndex, rowIndex);
        if (!!customValue)
          return customValue;
      }

      return col.Style;
    },
    getCellValue(col, row, colIndex, rowIndex) {
      if (Object.typeOf(this.option.fnCustomCellValue) === "function") {
        return this.option.fnCustomCellValue(col, row, colIndex, rowIndex);
      }

      return row[col.Name];
    },
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    doSearchWithOption(searchOption) {
      this.$emit("searchWithOption", searchOption);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    handleSearch() {
      this.currentPage = 1;
      this.loadData();
      //this.doSearchWithOption(searchOption);
    },
    getSearchOptions() {
      let startDate = ""; //this.searchDate[0].toISOString().split('T')[0];
      let endDate = ""; //this.searchDate[1].toISOString().split('T')[0];
      if (!!this.searchDate && this.searchDate.length == 2) {
        startDate = this.formatDate(this.searchDate[0]); //this.searchDate[0].toISOString().split('T')[0];
        endDate = this.formatDate(this.searchDate[1]); //this.searchDate[1].toISOString().split('T')[0];
      }
      let searchOption = {
        startDate: startDate,
        endDate: endDate
      };
      if (!!this.searchFilter) {
        searchOption["filterList"] = this.searchFilter;
      } else {
        searchOption["filterList"] = null;
      }
      return searchOption;
    },
    onSearchConditionChanged() {
      this.$emit("search", this.searchWord);
      this.handleSearch();
    },
    handleEnable(index, row) {
      this.$emit("enableChange", index, row);
    },
    handleJoinWeChatGroupValidate(index, row) {
      this.$emit("joinWeChatGroupValidateClick", index, row);
    },
    handleChangeCourse(index, row) {
      this.$emit("changeCourseClick", index, row);
    },
    handleVideoPackage(index, row) {
      this.$emit("videoPackageClick", index, row);
    },
    handleAdd() {
      this.$emit("add");
    },
    handleAdditionalBtn(){
      this.$emit("additionalBtnClick");
    },
    handleEdit(index, row) {
      this.$emit("edit", index, row);
    },
    getRowEditVisible(index, row) {
      if (!!this.option.fnRowEditVisible) {
        return this.option.fnRowEditVisible(index, row);
      }

      if (this.option.pageType == "salesQuery") {
        return row.Enable;
      }

      return this.option.hasEditButton;
    },
    handleDelete(index, row) {
      this.$emit("delete", index, row);
    },
    getRowDeleteVisible(index, row) {
      if (!!this.option.fnRowDeleteVisible) {
        return this.option.fnRowDeleteVisible(index, row);
      }

      return this.option.hasDeleteButton;
    },
    getRowDeleteDisabled(index, row) {
      if (!!this.option.fnRowDeleteDisabled) {
        return this.option.fnRowDeleteDisabled(index, row);
      }

      return false;
    },
    handleAdditional(name, index, row) {
      this.$emit("additional", name, index, row);
    },
    getTypeForAdditionalColumn(item, index, row){
      if (!!item.fnType){
        return item.fnType(index, row);
      }else{
        return "primary"
      }
    },
    getDisabledForAdditionalColumn(item, index, row){
      if (!!item.fnDisabled){
        return item.fnDisabled(index, row);
      }else{
        return false;
      }
    },
    getLoadingForAdditionalColumn(item, index, row) {
      if (!!item.fnLoading){
        return item.fnLoading(index, row);
      }else{
        return false;
      }
    },
    getVisibleForAdditionalColumn(item, index, row){
      if (!!item.fnVisible){
        return item.fnVisible(index, row);
      }else{
        return true;
      }
    },
    getRowClass({row, rowIndex}) {
      if (this.option.hideDisableRow) {
        return "";
      }

      if (Object.typeOf(this.option.fnCustomRowClass) === "function") {
        let customValue = this.option.fnCustomRowClass(row, rowIndex);
        if (!!customValue)
          return customValue;
      }

      if (typeof row.IsActive != "undefined") {
        if (!row.IsActive) {
          return "disabled-row";
        }
      }

      let isHighlight = false;
      if (this.highlightFields.length > 0){
        this.highlightFields.forEach(element => {
          if (!!row[element]){
            isHighlight = true;
          }
        });
      }
      if (isHighlight){
        return "highlight-row";
      }

      return "";
    },
    getEnableButtonClass(row) {
      if (!!row && !!row.Enable) {
        return "primary";
      }
      return "info";
    },
    getEnableButtonText(row) {
      if (!!row && !!row.Enable) {
        return "启用";
      }
      return "停用";
    },
    getEditButtonText(index, row) {
      if (!!this.option.fnRowEditButtonText) {
        return this.option.fnRowEditButtonText(index, row);
      }
      if (!!row && row.editButtonText) {
        return row.editButtonText;
      }
      if (!!this.option.editButtonText) {
        return this.option.editButtonText;
      }
      return "编辑";
    },
    getDeleteButtonText(scope) {
      if (!this.option.deleteButtonText) {
        return "删除";
      }
      return this.option.deleteButtonText;
    },
    sortChange(data) {
      this.isDesc = false;
      this.sortField = null;
      switch (data.order) {
        case "descending":
          this.sortField = data.prop;
          this.isDesc = true;
          break;
        case "ascending":
          this.sortField = data.prop;
          break;
      }

      this.loadData();
    },
    loadData() {
      let pageData = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        sortField: this.sortField,
        isDesc: this.isDesc,
        keyWord: this.searchWord
      };

      let startDate = ""; //this.searchDate[0].toISOString().split('T')[0];
      let endDate = ""; //this.searchDate[1].toISOString().split('T')[0];
      if (!!this.searchDate && this.searchDate.length == 2) {
        startDate = this.formatDate(this.searchDate[0]); //this.searchDate[0].toISOString().split('T')[0];
        endDate = this.formatDate(this.searchDate[1]); //this.searchDate[1].toISOString().split('T')[0];
      }
      pageData["startDate"] = startDate;
      pageData["endDate"] = endDate;
      if (!!this.searchFilter) {
        pageData["filterList"] = this.searchFilter;
      } else {
        pageData["filterList"] = null;
      }

      this.$emit("loadData", pageData);
    },
    pageSizeChange(value) {
      this.pageSize = value;
      this.currentPage = 1;
      this.$emit("pageSizeChange", value);
      this.loadData();
    },
    currentPageChange(value) {
      this.currentPage = value;
      this.$emit("currentPageChange", value);
      this.loadData();
    },
    initSetting() {
      // if (!this.data) {
      //   this.columns = [];
      //   return;
      // }
      //if (!!this.data)
      // this.columns = this.data.Columns;
    },
    // onCheckChange(value, row){
    //   if (!this.option.isMultipleCheck){

    //   }
    //   this.$emit("checkChange", {value: value, row: row});
    // }


    onCheck(selection, row) {
        if(!this.option.allowMutipleCheck){
        this.$refs.paginationTable.clearSelection();
        let isChecked = true;

        //一定有选中
        // if (selection.length === 0) {
        //   // 判断selection是否有值存在
        //   isChecked = false;
        // }

        if (!!row) {
          this.selectioned = row;
          this.$refs.paginationTable.toggleRowSelection(row, true);
          this.$emit("checkChange", row, isChecked);
        }
       }
    },
    selectionRowsChange(selecteds){
         this.$emit("checkChange", selecteds);
    },
    onCheckChange(row) {
      if (row.length === 0) {
        this.selectioned = null;
      }
    },
    setSelectedRow(){
      if (!!this.tableData && this.selectedKeyField && this.selectedKey){
        this.tableData.forEach(element => {
          if (element[this.selectedKeyField] == this.selectedKey){
            this.$refs.paginationTable.toggleRowSelection(element,true);
            this.$emit("checkChange", element, true);
          }
        });
      }
    },
    customEventHanlder(data){
      this.$emit("customEvent", data);
    },
    setSearchWord(value){
      this.searchWord = value;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (!!this.option.fnSpanMethod) {
        return this.option.fnSpanMethod({ row, column, rowIndex, columnIndex });
      }
    }
  },
  watch: {
    data: function() {
      this.initSetting();
      if (!!this.data) {
        this.currentPage = this.data.CurrentPage;
        this.recordTotal = this.data.RecordCount;
        this.columns = this.data.Columns;
        this.highlightFields = [];
        this.columns.forEach(element => {
          if (element.IsHighlightField){
            this.highlightFields.push(element.Name);
          }
        });
        this.displayedColumns = this.columns.filter(i =>{
          return this.checkIsVisiable(i);
        });
        this.tableData = this.data.Results;

      } else {
        this.tableData = [];
        this.recordTotal = 0;
        this.currentPage = 1;
        this.highlightFields = [];
      }
      this.$nextTick(function(){
        this.setSelectedRow();
      });
      this.loading = false;
    },
    selectedKey: function(){
      this.setSelectedRow();
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/pagination.vue